const outOfStock = '/events/rootstech-store' // eslint-disable-line no-unused-vars
const storeUrl = 'https://rootstechonlinestore2026.itemorder.com/shop/home/' // eslint-disable-line no-unused-vars
const storeConfig = {
  to: storeUrl,
}

export default storeConfig
